import * as PropTypes from 'prop-types';
import * as React from 'react';
import { without } from 'lodash';
import Pill from './pill';

const BrandSearchPills = ({ brands, changeBrands }) => {
  if (!brands) { return false; }

  return (
    <span>
      {
        brands.map((brand) => {
          const otherBrands = without(brands, brand);
          return <Pill key={brand} value={brand} onClick={() => changeBrands(otherBrands)} />;
        })
      }
    </span>
  );
};

BrandSearchPills.propTypes = {
  brands: PropTypes.array,
  changeBrands: PropTypes.func.isRequired,
};

export default BrandSearchPills;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/search_pills/brand_search_pills.jsx